import React, { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { I18nProvider, useI18n } from "@/lib/i18n";
import { AuthProvider } from "@/lib/auth";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Maintenance from "@/components/Maintenance";
import Landing from "@/pages/Landing";
import AdminLogin from "@/pages/AdminLogin";
import Dashboard from "@/pages/Dashboard";

function PublicShell({ children }) {
  const { applyDefault } = useI18n();
  const [pub, setPub] = useState(null);
  useEffect(() => {
    api.get("/public/settings")
      .then(({ data }) => { setPub(data); applyDefault(data.default_language.toLowerCase()); })
      .catch(() => setPub({}));
  }, [applyDefault]);
  if (pub === null) return <div className="min-h-screen bg-bg0" />;
  if (pub.maintenance_enabled) return <Maintenance message={pub.maintenance_message} />;
  return (
    <>
      <Navbar />
      {children}
    </>
  );
}

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster theme="dark" position="top-right" richColors />
          <Routes>
            <Route path="/" element={<PublicShell><Landing /></PublicShell>} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<Dashboard />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
